<template>
  <el-select
    v-model="status"
    style="width: 100px;"
    placeholder="请选择发货状态"
    @change="onChange">
    <el-option
      label="全部"
      :value="null">
    </el-option>
    <el-option
      v-for="item in listNew"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
import { OrderOutStatusName } from '../../utils/index'
export default {
  name: 'StatusSelect',
  props: {
    exclude: {
      type: Array,
      default() {
        return []
      }
    },
    callback: {
      type: Function
    },
    type: {
      type: String,
      default: 'select'
    },
    value: {
      required: true
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      list: OrderOutStatusName
    }
  },
  computed: {
    status: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    listNew({ list, exclude }) {
      return list.filter(i => exclude.indexOf(i.value) === -1)
    }
  },
  methods: {
    onChange() {
      this.callback && this.callback()
    }
  }
}
</script>
